import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import Header from '../header/Header';
import Sidebar from '../sidebar/Sidebar';
import { Grid } from 'antd';
import RoutesMap from '../../route_control/RouteControl';
import { SessionManager, showAccessDeniedAlert } from '../../utils';
const { useBreakpoint } = Grid;

const useAuth = () => {
    let user = SessionManager.getCookie("user_token");

    if (user) {
        try {
            if (user) {
                return user;
            }
        } catch (error) {
            return false
        }
    } else {
        return false
    }
}

const Auth = (props) => {
    const [collapsed, setCollapsed] = useState(false)
    const [drawerOpen, setDrawerOpen] = useState(false)

    const auth = useAuth()
    const navigate = useNavigate()
    const location = useLocation()

    const screens = useBreakpoint();
    const isMobileOrTablet = !screens.lg; // < 992px → treat as mobile

    var permission = JSON.parse(SessionManager.getSession('permission'))

    const isRouteAuthorized = permission && permission.some(
        (item) => item.route === location.pathname
    );

    if (!auth) {
        return <Navigate to={RoutesMap?.LOGIN?.path} />
    }
    // else if (!isRouteAuthorized) {
    //     if (auth && location.pathname == '/') {
    //         return <Navigate to={RoutesMap?.DASHBOARD?.path} />
    //     } else {
    //         showAccessDeniedAlert(navigate)
    //         return null;
    //     }
    // }
    else {
        return (
            <div>
                <Helmet>
                    <title>Salon Management System Admin Panel</title>
                </Helmet>
                <Header collapsed={collapsed} setCollapsed={setCollapsed} drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} isMobileOrTablet={isMobileOrTablet} />
                <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} isMobileOrTablet={isMobileOrTablet} />
                <div className={isMobileOrTablet ? 'outlet_mobile_view' : collapsed ? "outlet_collapsed" : "outlet_not_collapsed"}>
                    <Outlet />
                </div>
            </div>
        )
    }
}

export default Auth;